import { render } from "./TypeOfVouchers.vue?vue&type=template&id=3251f766"
import script from "./TypeOfVouchers.vue?vue&type=script&lang=js"
export * from "./TypeOfVouchers.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__